import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './SkeletonLoader.css'; // Custom CSS file for Skeleton styling

const SkeletonLoader = ({ rows, columns }) => {
  const skeletonArray = Array.from({ length: rows }, (_, rowIndex) => rowIndex);
  const columnSkeleton = Array.from({ length: columns }, (_, colIndex) => colIndex);

  return (
    <Container>
      {skeletonArray.map((rowIndex) => (
        <Row key={rowIndex} className="mb-3"> {/* Add 'mb-3' Bootstrap class for margin-bottom */}
          {columnSkeleton.map((colIndex) => (
            <Col xs={12 / columns} key={colIndex}>
              <div className="skeleton"></div>
            </Col>
          ))}
        </Row>
      ))}
    </Container>
  );
};

export default SkeletonLoader;
